import type { ReactNode } from "react";
import { RoleGuard } from "./RoleGuard";

interface AdminGuardProps {
  children: ReactNode;
}

/** Restricts access to admin users only. */
export function AdminGuard({ children }: AdminGuardProps) {
  return <RoleGuard minRole="admin">{children}</RoleGuard>;
}

/** Restricts access to manager or admin users. */
export function ManagerGuard({ children }: { children: ReactNode }) {
  return <RoleGuard minRole="manager">{children}</RoleGuard>;
}

/** Restricts access to viewer or above (any authenticated role). */
export function ViewerGuard({ children }: { children: ReactNode }) {
  return <RoleGuard minRole="viewer">{children}</RoleGuard>;
}
